import { CommonActionType } from "../../actions";
import LocalStorage from "../../utils/LocalStorage";

const getDefaultLanguage = () => {
  const setting = LocalStorage.getItem('setting');
  if (setting) {
    const parsedSettings = JSON.parse(setting);
    return parsedSettings.language || 'en';  // 如果找不到设置，则默认为英语
  }
  return 'en';  // 默认值
}

const DefaultCommonState = {
  miniSidenav: false,
  transparentSidenav: false,
  whiteSidenav: false,
  sidenavColor: "info",
  transparentNavbar: true,
  fixedNavbar: false,
  openConfigurator: false,
  direction: "ltr",
  layout: "page",
  darkMode: false,
  language:getDefaultLanguage(),
  cache:false
}

export const commonReducer = (
  state = DefaultCommonState,
  action = {}) =>
  {
    switch (action.type) {
      case CommonActionType.MINI_SIDENAV:
        return { ...state, miniSidenav: action.payload }

      case CommonActionType.TRANSPARENT_SIDENAV: {
        return { ...state, transparentSidenav: action.payload };
      }
      case CommonActionType.WHITE_SIDENAV: {
        return { ...state, whiteSidenav: action.payload };
      }
      case CommonActionType.SIDENAV_COLOR: {
        return { ...state, sidenavColor: action.payload };
      }
      case CommonActionType.TRANSPARENT_NAVBAR: {
        return { ...state, transparentNavbar: action.payload };
      }
      case CommonActionType.FIXED_NAVBAR: {
        return { ...state, fixedNavbar: action.payload };
      }
      case CommonActionType.OPEN_CONFIGURATOR: {
        return { ...state, openConfigurator: action.payload };
      }
      case CommonActionType.DIRECTION: {
        return { ...state, direction: action.payload };
      }
      case CommonActionType.LAYOUT: {
        return { ...state, layout: action.payload };
      }
      case CommonActionType.DARK_MODE: {
        return { ...state, darkMode: action.payload };
      }
      case CommonActionType.LANGUAGE: {
        return { ...state, language: action.payload };
      }
      case CommonActionType.Cache: {
        return { ...state, cache: action.payload };
      }
      default:
        return state;

    }

  }

export default commonReducer